/**
 * Canonical formatting helpers - replaces the 12 per-page fmtDate copies and
 * the 3 formatPrice variants.
 */

// ISO date (YYYY-MM-DD or full ISO) -> "18 Apr 2026"; '-' when absent/invalid.
export const fmtDate = (d) => {
  if (!d) return '-';
  const dt = new Date(d);
  return Number.isNaN(dt.getTime())
    ? '-'
    : dt.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
};

// Number -> localized string. decimals defaults to 2 for sub-100 values and
// 0 otherwise (matches how the public pages present prices).
export const formatPrice = (value, { decimals } = {}) => {
  if (value == null || Number.isNaN(Number(value))) return '-';
  const n = Number(value);
  const dp = decimals != null ? decimals : Math.abs(n) < 100 ? 2 : 0;
  return n.toLocaleString(undefined, { minimumFractionDigits: dp, maximumFractionDigits: dp });
};

export const fmtNumber = (n) => (n == null || Number.isNaN(Number(n)) ? '-' : Number(n).toLocaleString());
